import Resource from '@/api/core/resource'

class SystematicEconomics extends Resource {
  constructor () {
    super('Scores')
  }

  getModels(userId){
    return this.request.get(this.uri.concat('/ListModels/' +  userId))
  }
  getModelOutputs(request){
    return this.request.post(this.uri.concat('/GetModelOutputs'), request)
  }
  getJson(request){
    return this.request.post(this.uri.concat('/GetJson'),request)
  }
}

export default new SystematicEconomics()
